
define('template!companiesListFiltersEditView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="body">\n  <div class="line">\n    <div class="name item">\n      <div class="libelle">' +
((__t = ( _.i18n('common.name') )) == null ? '' : __t) +
'</div>\n      <input type="text" tabindex="1" autocomplete="off">\n    </div>\n    <div class="email-domain item">\n      <div class="libelle">' +
((__t = ( _.i18n('companies.emailDomain', null, 'Email domain') )) == null ? '' : __t) +
'</div>\n      <input type="text" tabindex="2" autocomplete="off">\n    </div>\n    <div class="country-code item">\n      <div class="libelle">' +
((__t = ( _.i18n('common.countryCode') )) == null ? '' : __t) +
'</div>\n      <input type="text" tabindex="3" autocomplete="off">\n    </div>\n  </div>\n</div>\n<div class="footer">\n  <div class="cancel-region"></div>\n  <div class="reset-region"></div>\n  <div class="confirm-region"></div>\n</div>\n';

}
return __p
};});

